import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { YouWarningIcon } from '../YouWarningIcon/YouWarningIcon';
import {
  ModalContent,
  ModalHeaderImage,
  Title,
  ModalDescription,
  ModalActions,
  PrimaryButton,
} from './styles';

export const YouCaptureErrorModal = ({
  title,
  description,
  retryLabel,
  closeModal = undefined,
  onRetry = undefined,
}) => {
  const handleRetry = useCallback(() => {
    closeModal?.();
    if (typeof onRetry === 'function') {
      setTimeout(() => onRetry(), 0);
    }
  }, [closeModal, onRetry]);

  return (
    <ModalContent data-testid="capture-error-modal">
      <ModalHeaderImage>
        <YouWarningIcon />
      </ModalHeaderImage>

      <Title data-testid="capture-error-title">{title}</Title>

      <ModalDescription data-testid="capture-error-description">
        {description}
      </ModalDescription>

      <ModalActions>
        <PrimaryButton
          type="button"
          onClick={handleRetry}
          data-testid="capture-error-retry"
        >
          {retryLabel}
        </PrimaryButton>
      </ModalActions>
    </ModalContent>
  );
};

YouCaptureErrorModal.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  retryLabel: PropTypes.node.isRequired,
  closeModal: PropTypes.func,
  onRetry: PropTypes.func,
};

export default YouCaptureErrorModal;
